import {ApiError} from '@mintdata-wsp/common/controllers/network/Fetcher';
import {Project} from '@mintdata-wsp/common/state/DataState';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {DataLine, DataLineColorType} from '@mintdata-wsp/wsp/ui/components/dataline/DataLine';
import {Row} from '@mintdata-wsp/wsp/ui/components/forms/Row';
import {MenuItem} from '@mintdata-wsp/wsp/ui/components/menus/MenuItem';
import {EditSpace} from '@mintdata-wsp/wsp/ui/views/workspace/settings/organization/spaces/EditSpace';
import bind from 'bind-decorator';
import * as classnames from 'classnames/bind';
import {action, observable} from 'mobx';
import {observer} from 'mobx-react';
import * as React from 'react';

const styles = require('./SpaceCard.less');
const cx = classnames.bind(styles);

export interface SpaceCardProps
{
    space:Project;
    isNew:boolean;
}

@observer
export class SpaceCard extends React.Component<SpaceCardProps, any>
{
    private _menuItems:MenuItem[] = this._computeMenu();

    @observable
    private _isEdit:boolean = false;

    // @observable
    // private _appCounter:number = 0;

    private _computeMenu():MenuItem[]
    {
        return [
            MenuItem.simple('rename', 'Rename', this._menuItemRenameSpace),
            // MenuItem.simple('duplicate', 'Duplicate', this._menuItemDuplicateSpace),
            MenuItem.separator(),
            MenuItem.simple('delete', 'Delete', this._menuItemDeleteSpace),
        ];
    }

    componentDidMount()
    {
        // const {space} = this.props;

        // controllers.data.designs.getDesignsForProject(space)
        // .then(action((designs:Design[]) =>
        // {
        //     this._appCounter = designs.length;
        // }));
    }

    @action.bound
    private _menuItemRenameSpace()
    {
        this._isEdit = true;
    }

    @action.bound
    private _closeEdit()
    {
        this._isEdit = false;
    }

    @action.bound
    private _onChangeName(newName)
    {
        const {space} = this.props;

        if( !newName || newName.trim().length === 0 ) return;

        controllers.data.projects
            .updateProject(space, newName.trim(), '')
            .then(action(() =>
            {
                this._isEdit = false;
            }))
            .catch((response:ApiError) =>
            {
                if( response.message )
                    throw(response.message);
            });
    }

    // @bind
    // private _menuItemDuplicateSpace()
    // {
    //     // const {space} = this.props;
    // }

    @bind
    private _menuItemDeleteSpace()
    {
        const {space} = this.props;
        // 'Please type the name of the space to delete it.',
        controllers.data.projects.deleteSpaceDialog(space).then(() =>
        {
            controllers.ui.dialogs.hideConfirmDialog();
        });
    }

    render()
    {
        const {space, isNew} = this.props;

        const isNewLine = isNew;

        const colorType = space.numOfDesigns ? DataLineColorType.Dark : DataLineColorType.Gray;

        return (
            <DataLine
                menuItems={this._isEdit ? null : this._menuItems}
                isNewLine={isNewLine}
                colorType={colorType}
                className={cx('spaceCard')}
            >
                <Row className={styles.content}>

                    <div className={cx('nameWrapper')}>
                        {space.name}
                    </div>

                    <div className={cx('app')}>
                        {space.numOfDesigns} application{space.numOfDesigns !== 1 ? 's' : ''}
                    </div>

                </Row>

                {this._isEdit && (
                    <EditSpace
                        className={cx('editMode')}
                        onClose={this._closeEdit}
                        onCreate={this._onChangeName}
                        initialValue={space.name}
                        buttonTitle={'Rename'}
                    />
                )}

            </DataLine>
        );
    }
}





